module.exports = __webpack_public_path__ + "img/wxm.c14eeafa.png";